// NWF Event Schedule — collapsible descriptions ("more …" / "less")
(function () {
    function toggle(button) {
        var wrapper = button.closest('[data-nwf-desc]');
        if (!wrapper) return;

        var shortEl = wrapper.querySelector('[data-nwf-desc-short]');
        var fullEl = wrapper.querySelector('[data-nwf-desc-full]');
        if (!shortEl || !fullEl) return;

        var expanded = !fullEl.hidden;
        fullEl.hidden = expanded;
        shortEl.hidden = !expanded;
        button.textContent = expanded ? button.dataset.labelMore : button.dataset.labelLess;
    }

    function init(root) {
        (root || document).querySelectorAll('[data-nwf-desc-toggle]').forEach(function (button) {
            if (button.dataset.nwfBound) return;
            button.dataset.nwfBound = 'true';
            button.addEventListener('click', function () {
                toggle(button);
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            init();
        });
    } else {
        init();
    }

    // Re-bind when the section is re-rendered in the theme editor.
    document.addEventListener('shopify:section:load', function (event) {
        init(event.target);
    });
})();
